import React from 'react';

function Hamburger({ color = 'text-shuttle-grey', size = 'w-6 h-6' }) {
	return (
		<div className={`fill-current ${color} ${size} mr-2`}>
			<svg viewBox="0 0 16 16" version="1.1">
				<g id="Icons---monochrome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="export">
						<rect id="box" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="16" height="16" />
						<path
							d="M15,12 C15.5522847,12 16,12.4477153 16,13 L16,13.6666667 C16,14.2189514 15.5522847,14.6666667 15,14.6666667 L1,14.6666667 C0.44771525,14.6666667 2.01876771e-16,14.2189514 0,13.6666667 L0,13 C-1.78657678e-16,12.4477153 0.44771525,12 1,12 L15,12 Z M15,6.66666667 C15.5522847,6.66666667 16,7.11438192 16,7.66666667 L16,8.33333333 C16,8.88561808 15.5522847,9.33333333 15,9.33333333 L1,9.33333333 C0.44771525,9.33333333 6.76353751e-17,8.88561808 0,8.33333333 L0,7.66666667 C-6.76353751e-17,7.11438192 0.44771525,6.66666667 1,6.66666667 L15,6.66666667 Z M15,1.33333333 C15.5522847,1.33333333 16,1.78104858 16,2.33333333 L16,3 C16,3.55228475 15.5522847,4 15,4 L1,4 C0.44771525,4 6.76353751e-17,3.55228475 0,3 L0,2.33333333 C-6.76353751e-17,1.78104858 0.44771525,1.33333333 1,1.33333333 L15,1.33333333 Z"
							id="menu"
							fill="currentcolor"
						/>
					</g>
				</g>
			</svg>
		</div>
	);
}

export default Hamburger;
